export default __webpack_public_path__ + "static/media/Titi-Adewusi.8c053baf.jpg";